import React from 'react';
import { LoginRuleCriteria } from 'src/components/login-rules/form/types';
import { LoginRuleCriteriaModal } from 'src/components/login-rules/form/login-rule-criteria/modal';
import { Confirmation } from '@otp/ui';
import { useTranslation } from 'react-i18next';

export enum LoginRuleCriteriaAction {
  Edit = 'edit',
  Delete = 'delete',
}

export const ActionModals = ({
  action,
  onClose,
  loginRuleCriteria,
  onActionFinished,
  index,
}: {
  action: LoginRuleCriteriaAction;
  onClose: () => void;
  onSubmitted?: (action: LoginRuleCriteriaAction) => void;
  loginRuleCriteria: LoginRuleCriteria;
  onActionFinished?: (
    action: LoginRuleCriteriaAction,
    { data, index }: { data: LoginRuleCriteria; index: number },
  ) => void;
  index: number;
}) => {
  const { t } = useTranslation();

  const onFinished = (data: LoginRuleCriteria) => {
    onActionFinished?.(action, { data, index });
    onClose();
  };

  return (
    <>
      {action === LoginRuleCriteriaAction.Edit && (
        <LoginRuleCriteriaModal
          defaultValues={loginRuleCriteria}
          onSubmit={onFinished}
          onClose={onClose}
        />
      )}
      {action === LoginRuleCriteriaAction.Delete && (
        <Confirmation
          open
          onClose={onClose}
          onConfirm={() => onFinished(loginRuleCriteria)}
          message={t(
            'login-rules.form.delete-login-rule-criteria-confirmation',
          )}
        />
      )}
    </>
  );
};
